module.exports = __webpack_public_path__ + "static/media/red-rectangle-802.ba6fdce8.svg";